import React from 'react';
import { Tag } from '../../types/tags';

interface TagDisplayProps {
	tag: Tag;
	className?: string;
	style?: React.CSSProperties;
	showassociatedPartsCount?: boolean;
}

const TagDisplay: React.FC<TagDisplayProps> = ({
	tag,
	className = '',
	style = {},
	showassociatedPartsCount = false,
}) => {
	return (
		<div className={` inline-flex w-full items-center justify-between  ${className}`} style={style}>
			<div className="flex items-center gap-2">
				<span
					className="inline-block h-3 w-3 flex-shrink-0 rounded-full"
					style={{ backgroundColor: tag.color }}
				/>
				<span className="bodyregular text-black/85">{tag.label}</span>
			</div>
			{showassociatedPartsCount && typeof tag.associatedPartsCount === 'number' ? (
				<span className="bodyregular text-black/45">({tag.associatedPartsCount})</span>
			) : null}
		</div>
	);
};

export default TagDisplay;
